import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import { SelectClientBanner } from "@/components";
import { useAppSelector } from "@/store";
import { roles } from "@/roles";
import DutyCalculatorComponent from "../product-catalogue/components/duty-calculator";

const DutyCalculatorPage: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);
  const { selectedClient } = useAppSelector((state) => state.client);
  const { selectedTenant } = useAppSelector((state) => state.tenantManagement);

  const canSelectClients = React.useMemo(() => {
    const allowedRoles = [roles.SPOWNER, roles.SPPARTNER, roles.TDADMIN] as string[];
    return allowedRoles.includes(user?.userRole ?? "");
  }, [user]);

  const isTDAdminTCD = React.useMemo(() => {
    return user?.userRole === roles.TDADMIN && selectedTenant?.tenantType === "TRADEDIVE_CLIENT";
  }, [user, selectedTenant]);

  if (canSelectClients && !selectedClient && !isTDAdminTCD) {
    return <SelectClientBanner />;
  }

  return (
    <Stack spacing={0} sx={{
      margin: {
        xs: '-6px -10px 0 -10px',
        md: '-12px -20px 0 -20px'
      },
      width: {
        xs: 'calc(100% + 20px)',
        md: 'calc(100% + 40px)'
      }
    }}>
      {/* Header Section */}
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ px: 3, pt: 2 }}>
        <Box>
          <Typography variant="h4" fontWeight={700} sx={{ mb: 1 }}>
            Duty Calculator
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Quickly calculate duties by HTS, origin, date, and metal percentage
          </Typography>
        </Box>
      </Stack>

      {/* Calculator Content */}
      <Box sx={{ px: 3, pt: 2 }}>
        <DutyCalculatorComponent />
      </Box>
    </Stack>
  );
};

export default DutyCalculatorPage;
